import { Alert, Text } from "@mantine/core";

export const PanelErrorFallback = ({ error }: { error: unknown }) => (
    <Alert variant="filled" color="error.7" title="Panel Error" m="sm">
        <Text size="sm">This panel encountered an error and couldn’t render properly.</Text>
        <Text size="xs" c="gray.3" mt="xs">
            {error instanceof Error ? error.message : String(error)}
        </Text>
    </Alert>
);
